import { env as P } from "@fond-of/env";
import { localizedTopLevelDomains as De, currentLocale as ee } from "@fond-of/locale";
import { getToken as ze, isTokenExpired as qe, logout as ke } from "@fond-of/token-manager";
import { Storage as Ne } from "@fond-of/storage";
class G extends Error {
  constructor(e, n, r) {
    const i = e.status || e.status === 0 ? e.status : "", o = e.statusText || "", s = `${i} ${o}`.trim(), a = s ? `status code ${s}` : "an unknown error";
    super(`Request failed with ${a}`), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "HTTPError", this.response = e, this.request = n, this.options = r;
  }
}
class te extends Error {
  constructor(e) {
    super("Request timed out"), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "TimeoutError", this.request = e;
  }
}
const E = (t) => t !== null && typeof t == "object", S = (...t) => {
  for (const e of t)
    if ((!E(e) || Array.isArray(e)) && e !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return U({}, ...t);
}, re = (t = {}, e = {}) => {
  const n = new globalThis.Headers(t), r = e instanceof globalThis.Headers, i = new globalThis.Headers(e);
  for (const [o, s] of i.entries())
    r && s === "undefined" || s === void 0 ? n.delete(o) : n.set(o, s);
  return n;
}, U = (...t) => {
  let e = {}, n = {};
  for (const r of t)
    if (Array.isArray(r))
      Array.isArray(e) || (e = []), e = [...e, ...r];
    else if (E(r)) {
      for (let [i, o] of Object.entries(r))
        E(o) && i in e && (o = U(e[i], o)), e = { ...e, [i]: o };
      E(r.headers) && (n = re(n, r.headers), e.headers = n);
    }
  return e;
}, He = (() => {
  let t = !1, e = !1;
  const n = typeof globalThis.ReadableStream == "function", r = typeof globalThis.Request == "function";
  return n && r && (e = new globalThis.Request("https://empty.invalid", {
    body: new globalThis.ReadableStream(),
    method: "POST",
    // @ts-expect-error - Types are outdated.
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type")), t && !e;
})(), xe = typeof globalThis.AbortController == "function", Je = typeof globalThis.ReadableStream == "function", Ue = typeof globalThis.FormData == "function", ne = ["get", "post", "put", "patch", "head", "delete"], Be = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, q = 2147483647, ie = Symbol("stop"), Le = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  fetch: !0
}, Fe = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, $e = (t) => ne.includes(t) ? t.toUpperCase() : t, Ke = ["get", "put", "head", "delete", "options", "trace"], Ge = [408, 413, 429, 500, 502, 503, 504], oe = [413, 429, 503], V = {
  limit: 2,
  methods: Ke,
  statusCodes: Ge,
  afterStatusCodes: oe,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (t) => 0.3 * 2 ** (t - 1) * 1e3
}, Ve = (t = {}) => {
  if (typeof t == "number")
    return {
      ...V,
      limit: t
    };
  if (t.methods && !Array.isArray(t.methods))
    throw new Error("retry.methods must be an array");
  if (t.statusCodes && !Array.isArray(t.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...V,
    ...t,
    afterStatusCodes: oe
  };
};
async function We(t, e, n, r) {
  return new Promise((i, o) => {
    const s = setTimeout(() => {
      n && n.abort(), o(new te(t));
    }, r.timeout);
    r.fetch(t, e).then(i).catch(o).then(() => {
      clearTimeout(s);
    });
  });
}
async function Xe(t, { signal: e }) {
  return new Promise((n, r) => {
    e && (e.throwIfAborted(), e.addEventListener("abort", i, { once: !0 }));
    function i() {
      clearTimeout(o), r(e.reason);
    }
    const o = setTimeout(() => {
      e == null || e.removeEventListener("abort", i), n();
    }, t);
  });
}
const Ye = (t, e) => {
  const n = {};
  for (const r in e)
    !(r in Fe) && !(r in Le) && !(r in t) && (n[r] = e[r]);
  return n;
};
class A {
  static create(e, n) {
    const r = new A(e, n), i = async () => {
      if (typeof r._options.timeout == "number" && r._options.timeout > q)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${q}`);
      await Promise.resolve();
      let a = await r._fetch();
      for (const c of r._options.hooks.afterResponse) {
        const u = await c(r.request, r._options, r._decorateResponse(a.clone()));
        u instanceof globalThis.Response && (a = u);
      }
      if (r._decorateResponse(a), !a.ok && r._options.throwHttpErrors) {
        let c = new G(a, r.request, r._options);
        for (const u of r._options.hooks.beforeError)
          c = await u(c);
        throw c;
      }
      if (r._options.onDownloadProgress) {
        if (typeof r._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!Je)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return r._stream(a.clone(), r._options.onDownloadProgress);
      }
      return a;
    }, s = r._options.retry.methods.includes(r.request.method.toLowerCase()) ? r._retry(i) : i();
    for (const [a, c] of Object.entries(Be))
      s[a] = async () => {
        r.request.headers.set("accept", r.request.headers.get("accept") || c);
        const l = (await s).clone();
        if (a === "json") {
          if (l.status === 204 || (await l.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (n.parseJson)
            return n.parseJson(await l.text());
        }
        return l[a]();
      };
    return s;
  }
  // eslint-disable-next-line complexity
  constructor(e, n = {}) {
    var i, o;
    Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "abortController", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "_input", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._input = e;
    const r = this._input instanceof Request && "credentials" in Request.prototype ? this._input.credentials : void 0;
    if (this._options = {
      ...r && { credentials: r },
      // For exactOptionalPropertyTypes
      ...n,
      headers: re(this._input.headers, n.headers),
      hooks: U({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: $e(n.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: Ve(n.retry),
      throwHttpErrors: n.throwHttpErrors !== !1,
      timeout: n.timeout ?? 1e4,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (xe) {
      if (this.abortController = new globalThis.AbortController(), this._options.signal) {
        const s = this._options.signal;
        this._options.signal.addEventListener("abort", () => {
          this.abortController.abort(s.reason);
        });
      }
      this._options.signal = this.abortController.signal;
    }
    if (He && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const a = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), c = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, a);
      (Ue && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(c, { ...this.request }), this._options);
    }
    this._options.json !== void 0 && (this._options.body = ((o = (i = this._options).stringifyJson) == null ? void 0 : o.call(i, this._options.json)) ?? JSON.stringify(this._options.json), this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json"), this.request = new globalThis.Request(this.request, { body: this._options.body }));
  }
  _calculateRetryDelay(e) {
    if (this._retryCount++, this._retryCount <= this._options.retry.limit && !(e instanceof te)) {
      if (e instanceof G) {
        if (!this._options.retry.statusCodes.includes(e.response.status))
          return 0;
        const r = e.response.headers.get("Retry-After");
        if (r && this._options.retry.afterStatusCodes.includes(e.response.status)) {
          let i = Number(r);
          return Number.isNaN(i) ? i = Date.parse(r) - Date.now() : i *= 1e3, this._options.retry.maxRetryAfter !== void 0 && i > this._options.retry.maxRetryAfter ? 0 : i;
        }
        if (e.response.status === 413)
          return 0;
      }
      const n = this._options.retry.delay(this._retryCount);
      return Math.min(this._options.retry.backoffLimit, n);
    }
    return 0;
  }
  _decorateResponse(e) {
    return this._options.parseJson && (e.json = async () => this._options.parseJson(await e.text())), e;
  }
  async _retry(e) {
    try {
      return await e();
    } catch (n) {
      const r = Math.min(this._calculateRetryDelay(n), q);
      if (r !== 0 && this._retryCount > 0) {
        await Xe(r, { signal: this._options.signal });
        for (const i of this._options.hooks.beforeRetry)
          if (await i({
            request: this.request,
            options: this._options,
            error: n,
            retryCount: this._retryCount
          }) === ie)
            return;
        return this._retry(e);
      }
      throw n;
    }
  }
  async _fetch() {
    for (const n of this._options.hooks.beforeRequest) {
      const r = await n(this.request, this._options);
      if (r instanceof Request) {
        this.request = r;
        break;
      }
      if (r instanceof Response)
        return r;
    }
    const e = Ye(this.request, this._options);
    return this._options.timeout === !1 ? this._options.fetch(this.request.clone(), e) : We(this.request.clone(), e, this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(e, n) {
    const r = Number(e.headers.get("content-length")) || 0;
    let i = 0;
    return e.status === 204 ? (n && n({ percent: 1, totalBytes: r, transferredBytes: i }, new Uint8Array()), new globalThis.Response(null, {
      status: e.status,
      statusText: e.statusText,
      headers: e.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(o) {
        const s = e.body.getReader();
        n && n({ percent: 0, transferredBytes: 0, totalBytes: r }, new Uint8Array());
        async function a() {
          const { done: c, value: u } = await s.read();
          if (c) {
            o.close();
            return;
          }
          if (n) {
            i += u.byteLength;
            const l = r === 0 ? 0 : i / r;
            n({ percent: l, transferredBytes: i, totalBytes: r }, u);
          }
          o.enqueue(u), await a();
        }
        await a();
      }
    }), {
      status: e.status,
      statusText: e.statusText,
      headers: e.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const N = (t) => {
  const e = (n, r) => A.create(n, S(t, r));
  for (const n of ne)
    e[n] = (r, i) => A.create(r, S(t, i, { method: n }));
  return e.create = (n) => N(S(n)), e.extend = (n) => N(S(t, n)), e.stop = ie, e;
}, Qe = N();
function Ze(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var H = {}, B = {}, v = {};
Object.defineProperty(v, "__esModule", { value: !0 });
v.isPlainObject = v.jsonParse = v.createIncludeNamesTree = void 0;
function se(t, e) {
  var n = t.split("."), r = n.shift(), i = n.length, o = null;
  i && (o = e[r] || {}, se(n.join("."), o)), e[r] = o;
}
v.createIncludeNamesTree = se;
function et(t) {
  var e;
  try {
    e = JSON.parse(t);
  } catch (n) {
    e = {}, console.warn(n);
  }
  return e;
}
v.jsonParse = et;
var tt = function(t) {
  return !!t && typeof t == "object" && t.constructor === Object;
};
v.isPlainObject = tt;
var R = {}, x = function(t, e) {
  return x = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, x(t, e);
};
function ae(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  x(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var C = function() {
  return C = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, C.apply(this, arguments);
};
function ue(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function ce(t, e, n, r) {
  var i = arguments.length, o = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(t, e, n, r);
  else for (var a = t.length - 1; a >= 0; a--) (s = t[a]) && (o = (i < 3 ? s(o) : i > 3 ? s(e, n, o) : s(e, n)) || o);
  return i > 3 && o && Object.defineProperty(e, n, o), o;
}
function le(t, e) {
  return function(n, r) {
    e(n, r, t);
  };
}
function rt(t, e, n, r, i, o) {
  function s(m) {
    if (m !== void 0 && typeof m != "function") throw new TypeError("Function expected");
    return m;
  }
  for (var a = r.kind, c = a === "getter" ? "get" : a === "setter" ? "set" : "value", u = !e && t ? r.static ? t : t.prototype : null, l = e || (u ? Object.getOwnPropertyDescriptor(u, r.name) : {}), f, h = !1, p = n.length - 1; p >= 0; p--) {
    var y = {};
    for (var b in r) y[b] = b === "access" ? {} : r[b];
    for (var b in r.access) y.access[b] = r.access[b];
    y.addInitializer = function(m) {
      if (h) throw new TypeError("Cannot add initializers after decoration has completed");
      o.push(s(m || null));
    };
    var _ = (0, n[p])(a === "accessor" ? { get: l.get, set: l.set } : l[c], y);
    if (a === "accessor") {
      if (_ === void 0) continue;
      if (_ === null || typeof _ != "object") throw new TypeError("Object expected");
      (f = s(_.get)) && (l.get = f), (f = s(_.set)) && (l.set = f), (f = s(_.init)) && i.unshift(f);
    } else (f = s(_)) && (a === "field" ? i.unshift(f) : l[c] = f);
  }
  u && Object.defineProperty(u, r.name, l), h = !0;
}
function nt(t, e, n) {
  for (var r = arguments.length > 2, i = 0; i < e.length; i++)
    n = r ? e[i].call(t, n) : e[i].call(t);
  return r ? n : void 0;
}
function it(t) {
  return typeof t == "symbol" ? t : "".concat(t);
}
function ot(t, e, n) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t, "name", { configurable: !0, value: n ? "".concat(n, " ", e) : e });
}
function fe(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(t, e);
}
function pe(t, e, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function a(l) {
      try {
        u(r.next(l));
      } catch (f) {
        s(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        s(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(a, c);
    }
    u((r = r.apply(t, e || [])).next());
  });
}
function he(t, e) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = e.call(t, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
var D = Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(e, n);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, i);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
};
function de(t, e) {
  for (var n in t) n !== "default" && !Object.prototype.hasOwnProperty.call(e, n) && D(e, t, n);
}
function I(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function L(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), i, o = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function ye() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(L(arguments[e]));
  return t;
}
function be() {
  for (var t = 0, e = 0, n = arguments.length; e < n; e++) t += arguments[e].length;
  for (var r = Array(t), i = 0, e = 0; e < n; e++)
    for (var o = arguments[e], s = 0, a = o.length; s < a; s++, i++)
      r[i] = o[s];
  return r;
}
function ve(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, i = e.length, o; r < i; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function w(t) {
  return this instanceof w ? (this.v = t, this) : new w(t);
}
function _e(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), i, o = [];
  return i = {}, a("next"), a("throw"), a("return", s), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function s(p) {
    return function(y) {
      return Promise.resolve(y).then(p, f);
    };
  }
  function a(p, y) {
    r[p] && (i[p] = function(b) {
      return new Promise(function(_, m) {
        o.push([p, b, _, m]) > 1 || c(p, b);
      });
    }, y && (i[p] = y(i[p])));
  }
  function c(p, y) {
    try {
      u(r[p](y));
    } catch (b) {
      h(o[0][3], b);
    }
  }
  function u(p) {
    p.value instanceof w ? Promise.resolve(p.value.v).then(l, f) : h(o[0][2], p);
  }
  function l(p) {
    c("next", p);
  }
  function f(p) {
    c("throw", p);
  }
  function h(p, y) {
    p(y), o.shift(), o.length && c(o[0][0], o[0][1]);
  }
}
function me(t) {
  var e, n;
  return e = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function r(i, o) {
    e[i] = t[i] ? function(s) {
      return (n = !n) ? { value: w(t[i](s)), done: !1 } : o ? o(s) : s;
    } : o;
  }
}
function we(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof I == "function" ? I(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = t[o] && function(s) {
      return new Promise(function(a, c) {
        s = t[o](s), i(a, c, s.done, s.value);
      });
    };
  }
  function i(o, s, a, c) {
    Promise.resolve(c).then(function(u) {
      o({ value: u, done: a });
    }, s);
  }
}
function ge(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
var st = Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
};
function Me(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var n in t) n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && D(e, t, n);
  return st(e, t), e;
}
function Re(t) {
  return t && t.__esModule ? t : { default: t };
}
function Oe(t, e, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !r : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(t) : r ? r.value : e.get(t);
}
function Pe(t, e, n, r, i) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !i) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(t, n) : i ? i.value = n : e.set(t, n), n;
}
function Se(t, e) {
  if (e === null || typeof e != "object" && typeof e != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t == "function" ? e === t : t.has(e);
}
function je(t, e, n) {
  if (e != null) {
    if (typeof e != "object" && typeof e != "function") throw new TypeError("Object expected.");
    var r, i;
    if (n) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      r = e[Symbol.asyncDispose];
    }
    if (r === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      r = e[Symbol.dispose], n && (i = r);
    }
    if (typeof r != "function") throw new TypeError("Object not disposable.");
    i && (r = function() {
      try {
        i.call(this);
      } catch (o) {
        return Promise.reject(o);
      }
    }), t.stack.push({ value: e, dispose: r, async: n });
  } else n && t.stack.push({ async: !0 });
  return e;
}
var at = typeof SuppressedError == "function" ? SuppressedError : function(t, e, n) {
  var r = new Error(n);
  return r.name = "SuppressedError", r.error = t, r.suppressed = e, r;
};
function Ee(t) {
  function e(r) {
    t.error = t.hasError ? new at(r, t.error, "An error was suppressed during disposal.") : r, t.hasError = !0;
  }
  function n() {
    for (; t.stack.length; ) {
      var r = t.stack.pop();
      try {
        var i = r.dispose && r.dispose.call(r.value);
        if (r.async) return Promise.resolve(i).then(n, function(o) {
          return e(o), n();
        });
      } catch (o) {
        e(o);
      }
    }
    if (t.hasError) throw t.error;
  }
  return n();
}
const ut = {
  __extends: ae,
  __assign: C,
  __rest: ue,
  __decorate: ce,
  __param: le,
  __metadata: fe,
  __awaiter: pe,
  __generator: he,
  __createBinding: D,
  __exportStar: de,
  __values: I,
  __read: L,
  __spread: ye,
  __spreadArrays: be,
  __spreadArray: ve,
  __await: w,
  __asyncGenerator: _e,
  __asyncDelegator: me,
  __asyncValues: we,
  __makeTemplateObject: ge,
  __importStar: Me,
  __importDefault: Re,
  __classPrivateFieldGet: Oe,
  __classPrivateFieldSet: Pe,
  __classPrivateFieldIn: Se,
  __addDisposableResource: je,
  __disposeResources: Ee
}, ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: je,
  get __assign() {
    return C;
  },
  __asyncDelegator: me,
  __asyncGenerator: _e,
  __asyncValues: we,
  __await: w,
  __awaiter: pe,
  __classPrivateFieldGet: Oe,
  __classPrivateFieldIn: Se,
  __classPrivateFieldSet: Pe,
  __createBinding: D,
  __decorate: ce,
  __disposeResources: Ee,
  __esDecorate: rt,
  __exportStar: de,
  __extends: ae,
  __generator: he,
  __importDefault: Re,
  __importStar: Me,
  __makeTemplateObject: ge,
  __metadata: fe,
  __param: le,
  __propKey: it,
  __read: L,
  __rest: ue,
  __runInitializers: nt,
  __setFunctionName: ot,
  __spread: ye,
  __spreadArray: ve,
  __spreadArrays: be,
  __values: I,
  default: ut
}, Symbol.toStringTag, { value: "Module" })), F = /* @__PURE__ */ Ze(ct);
Object.defineProperty(R, "__esModule", { value: !0 });
R.ModelsSerializer = void 0;
var k = F, lt = v, Te = function() {
  function t(e) {
    e && this.setPropertiesMapper(e), this.buildIncludedIndex = 0;
  }
  return t.prototype.setPropertiesMapper = function(e) {
    this.propertiesMapper = e;
  }, t.prototype.setStuff = function(e) {
    this.stuff = e;
  }, t.prototype.setIncludeNames = function(e) {
    if (Array.isArray(e)) {
      var n = {};
      e.forEach(function(r) {
        (0, lt.createIncludeNamesTree)(r, n);
      }), this.includeNamesTree = n;
    } else
      this.includeNamesTree = e;
  }, t.prototype.build = function() {
    var e = this, n = e.stuff, r = e.propertiesMapper;
    if (!r || typeof r != "object")
      throw new Error("ModelsSerializer cannot build, propertiesMapper is not set");
    if (!n || typeof n != "object")
      throw new Error("ModelsSerializer cannot build, stuff is not set");
    var i = {}, o = {};
    if (n && Array.isArray(n)) {
      for (var s = n.length, a = [], c = 0; c < s; c++)
        a.push(this.buildDataByModel(n[c])), this.buildIncludedByModel(n[c], this.includeNamesTree, o);
      i.data = a;
    } else n ? (i.data = this.buildDataByModel(n), this.buildIncludedByModel(n, this.includeNamesTree, o)) : n === null && (i.data = null);
    return Object.keys(o).length && (i.included = Object.values(o)), i;
  }, t.prototype.buildDataByModel = function(e) {
    var n = this.propertiesMapper.getId(e), r = this.propertiesMapper.getType(e), i = this.propertiesMapper.getAttributes(e), o = k.__assign(k.__assign({ type: r }, typeof n < "u" ? { id: n } : {}), typeof i < "u" ? { attributes: i } : {});
    if (typeof o.type != "string" || !o.type)
      throw console.warn("ModelsSerializer cannot buildDataByModel, type is not set or incorrect", e), new Error("ModelsSerializer cannot buildDataByModel, type is not set or incorrect");
    var s = this.buildRelationshipsByModel(e);
    return s && Object.keys(s).length && (o.relationships = s), o;
  }, t.prototype.buildResourceObjectPart = function(e) {
    var n = this.propertiesMapper.getId(e), r = this.propertiesMapper.getType(e);
    return k.__assign({ type: r }, typeof n > "u" ? {} : { id: n });
  }, t.prototype.buildRelationshipsByModel = function(e) {
    var n = this, r = this.propertiesMapper.getRelationships(e);
    if (!(!r || !Object.keys(r).length)) {
      var i = {};
      return Object.keys(r).forEach(function(o) {
        var s = r[o];
        if (Array.isArray(s)) {
          for (var a = [], c = 0, u = s; c < u.length; c++) {
            var l = u[c], f = n.buildResourceObjectPart(l);
            "type" in f ? a.push(f) : console.error("Can't create data item for relationship ".concat(o, `,
                            it doesn't have 'id' or 'type', it was skipped`), l);
          }
          i[o] = {
            data: a
          };
        } else if (s) {
          var h = n.buildResourceObjectPart(s);
          "type" in h ? i[o] = {
            data: h
          } : console.error("Can't create data for relationship ".concat(o, ", it doesn't have 'type', it was skipped"), s);
        } else
          i[o] = {
            data: s
          };
      }), i;
    }
  }, t.prototype.buildIncludedByModel = function(e, n, r) {
    if (r === void 0 && (r = {}), !(!n || !Object.keys(n).length)) {
      var i = this.propertiesMapper.getRelationships(e);
      if (!(!i || !Object.keys(i).length))
        for (var o = Object.keys(n), s = o.length, a = 0; a < s; a++) {
          var c = o[a], u = i[c];
          if (u)
            if (Array.isArray(u))
              for (var l = u.length, f = 0; f < l; f++) {
                var h = u[f];
                this.buildIncludedItem(h, n[c], r);
              }
            else
              this.buildIncludedItem(u, n[c], r);
        }
    }
  }, t.prototype.buildIncludedItem = function(e, n, r) {
    var i = this.propertiesMapper.getId(e), o = this.propertiesMapper.getType(e), s = o + i;
    (!i || !r[s]) && (s in r && (s += this.buildIncludedIndex, this.buildIncludedIndex += 1), r[s] = this.buildDataByModel(e), n && this.buildIncludedByModel(e, n, r));
  }, t;
}();
R.ModelsSerializer = Te;
R.default = Te;
var O = {};
Object.defineProperty(O, "__esModule", { value: !0 });
O.JsonDeserializer = void 0;
var Ae = function() {
  function t(e, n, r) {
    this.preferNestedDataFromData = !1, this.setPropertiesMapper(e), this.setDeserializeCache(n), r && r.preferNestedDataFromData && (this.preferNestedDataFromData = !0);
  }
  return t.prototype.setDeserializeCache = function(e) {
    this.dc = e;
  }, t.prototype.setPropertiesMapper = function(e) {
    this.pm = e;
  }, t.prototype.setJsonParsedObject = function(e) {
    this.body = e;
  }, t.prototype.build = function() {
    var e = this.body.data, n;
    if (Array.isArray(e)) {
      n = [];
      for (var r = e.length, i = 0; i < r; i++)
        if (e[i]) {
          var o = this.buildModelByData(e[i]);
          o && n.push(o);
        }
    } else e && (n = this.buildModelByData(e));
    return n;
  }, t.prototype.buildModelByData = function(e, n) {
    var r = this.dc.getCachedModel(e, n);
    if (r)
      return r;
    var i = this.pm.createModel(e.type);
    if (this.dc.handleModel(i, e, n), i) {
      this.pm.setId(i, e.id), e.attributes && this.pm.setAttributes(i, e.attributes), e.meta && this.pm.setMeta && this.pm.setMeta(i, e.meta), e.links && this.pm.setLinks && this.pm.setLinks(i, e.links), n != null && n.meta && this.pm.setResourceIdObjMeta(i, n.meta);
      var o = this.buildRelationsByData(e, i);
      o && this.pm.setRelationships(i, o);
    }
    return i;
  }, t.prototype.buildRelationsByData = function(e, n) {
    var r = {};
    if (e.relationships)
      for (var i in e.relationships) {
        var o = e.relationships[i];
        if (Array.isArray(o.data)) {
          r[i] = [];
          for (var s = o.data.length, a = void 0, c = 0; c < s; c++)
            if (a = o.data[c], !!a) {
              var u = this.buildDataFromIncludedOrData(a.id, a.type);
              r[i].push(this.buildModelByData(u, a));
            }
        } else if (o.data) {
          var u = this.buildDataFromIncludedOrData(o.data.id, o.data.type);
          r[i] = this.buildModelByData(u, o.data);
        } else o.data === null && (r[i] = null);
        if (o.links) {
          var l = this.pm.setRelationshipLinks;
          l && l(n, i, o.links);
        }
        if (o.meta) {
          var f = this.pm.setRelationshipMeta;
          f && f(n, i, o.meta);
        }
      }
    return Object.keys(r).length ? r : null;
  }, t.prototype.buildDataFromIncludedOrData = function(e, n) {
    if (this.preferNestedDataFromData) {
      var r = this.buildDataInObject(), i = r[n + e];
      if (i)
        return i;
    }
    var o = this.buildIncludedInObject(), s = o[n + e];
    if (s)
      return s;
    if (!this.preferNestedDataFromData) {
      var r = this.buildDataInObject(), i = r[n + e];
      if (i)
        return i;
    }
    return { id: e, type: n };
  }, t.prototype.buildDataInObject = function() {
    if (!this.dataInObject) {
      this.dataInObject = {};
      var e = this.body.data, n = e.length;
      if (e && n)
        for (var r = 0; r < n; r++) {
          var i = e[r];
          this.dataInObject[i.type + i.id] = i;
        }
      else e && (this.dataInObject[e.type + e.id] = e);
    }
    return this.dataInObject;
  }, t.prototype.buildIncludedInObject = function() {
    if (!this.includedInObject && (this.includedInObject = {}, this.body.included))
      for (var e = this.body.included.length, n = 0; n < e; n++) {
        var r = this.body.included[n];
        this.includedInObject[r.type + r.id] = r;
      }
    return this.includedInObject;
  }, t;
}();
O.JsonDeserializer = Ae;
O.default = Ae;
var $ = {};
Object.defineProperty($, "__esModule", { value: !0 });
var ft = function() {
  function t(e) {
    this.cachedModels = {}, this.setPropertiesMapper(e);
  }
  return t.prototype.setPropertiesMapper = function(e) {
    this.propertiesMapper = e;
  }, t.prototype.setReduxObject = function(e) {
    this.reduxObject = e;
  }, t.prototype.setEntityType = function(e) {
    this.entityType = e;
  }, t.prototype.setEntityIds = function(e) {
    this.ids = e;
  }, t.prototype.setReturnBuilderInRelations = function(e) {
    this.returnBuilderInRelations = e;
  }, t.prototype.build = function() {
    var e = this, n = this, r = n.reduxObject, i = n.entityType, o = n.propertiesMapper;
    if (!o || typeof o != "object")
      throw new Error("ReduxObjectDenormalizer cannot build, propertiesMapper is not set");
    if (!r || typeof r != "object")
      throw new Error("ReduxObjectDenormalizer cannot build, reduxObject is not set");
    if (!i)
      throw new Error("ReduxObjectDenormalizer cannot build, entityType is not set");
    if (!r[i])
      return null;
    var s = this.ids;
    if (s || (s = Object.keys(r[i])), Array.isArray(s)) {
      if (!s.length)
        return null;
      var a = [];
      return s.forEach(function(c) {
        var u = e.buildModel(i, c);
        u && a.push(u);
      }), a;
    }
    return this.buildModel(i, s);
  }, t.prototype.buildModel = function(e, n) {
    var r = this.reduxObject;
    if (!r[e])
      return null;
    var i = r[e][n];
    if (!i)
      return null;
    var o = "".concat(e, "-").concat(n), s = this.cachedModels[o];
    if (!s && (s = this.propertiesMapper.createModel(e), s)) {
      this.cachedModels[o] = s, this.propertiesMapper.setId(s, i.id), i.attributes && this.propertiesMapper.setAttributes(s, i.attributes);
      var a = this.buildRelationships(s, i.relationships);
      a && this.propertiesMapper.setRelationships(s, a);
    }
    return s;
  }, t.prototype.buildRelationships = function(e, n) {
    var r = this;
    if (!n)
      return null;
    var i = Object.keys(n);
    if (!i.length)
      return null;
    var o = {};
    return i.forEach(function(s) {
      var a = n[s];
      if (a && a.data && (r.returnBuilderInRelations ? o[s] = r.buildRelationModels.bind(r, a.data) : o[s] = r.buildRelationModels(a.data)), a && a.links && r.propertiesMapper.setRelationshipLinks(e, s, a.links), a && a.meta) {
        var c = r.propertiesMapper.setRelationshipMeta;
        c && c(e, s, a.meta);
      }
    }), Object.keys(o).length ? o : null;
  }, t.prototype.buildRelationModels = function(e) {
    var n = this;
    if (Array.isArray(e)) {
      var r = [];
      return e.forEach(function(i) {
        var o = n.buildModel(i.type, i.id);
        r.push(o || i);
      }), r;
    } else if (e.id && e.type)
      return this.buildModel(e.type, e.id) || e;
    return null;
  }, t;
}();
$.default = ft;
var z = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.JsonPropertiesMapper = t.defineRelationGetter = t.ModelPropertiesMapper = t.RELATIONSHIP_NAMES_PROP = void 0;
  var e = F;
  t.RELATIONSHIP_NAMES_PROP = "relationshipNames";
  var n = function() {
    function o() {
    }
    return o.prototype.getId = function(s) {
      return s.id;
    }, o.prototype.getType = function(s) {
      return s.type;
    }, o.prototype.getAttributes = function(s) {
      var a = ["id", "type", t.RELATIONSHIP_NAMES_PROP];
      Array.isArray(s[t.RELATIONSHIP_NAMES_PROP]) ? a.push.apply(a, s[t.RELATIONSHIP_NAMES_PROP]) : s[t.RELATIONSHIP_NAMES_PROP] && console.warn("Can't getAttributes correctly, '".concat(t.RELATIONSHIP_NAMES_PROP, "' property of ").concat(s.type, "-").concat(s.id, ` model
                isn't array of relationship names`), s[t.RELATIONSHIP_NAMES_PROP]);
      var c = {};
      return Object.keys(s).forEach(function(u) {
        a.indexOf(u) === -1 && (c[u] = s[u]);
      }), c;
    }, o.prototype.getRelationships = function(s) {
      var a = s[t.RELATIONSHIP_NAMES_PROP];
      if (!(!a || Array.isArray(a) && !a.length)) {
        if (a && !Array.isArray(a)) {
          console.warn(`Can't getRelationships correctly,
                '`.concat(t.RELATIONSHIP_NAMES_PROP, "' property of ").concat(s.type, "-").concat(s.id, ` model
                isn't array of relationship names`), s[t.RELATIONSHIP_NAMES_PROP]);
          return;
        }
        var c = {};
        return a.forEach(function(u) {
          s[u] !== void 0 && (c[u] = s[u]);
        }), c;
      }
    }, o;
  }();
  t.ModelPropertiesMapper = n;
  function r(o, s, a) {
    Object.defineProperty(o, s, {
      enumerable: !0,
      configurable: !0,
      set: function(c) {
        delete o[s], o[s] = c;
      },
      get: function() {
        return delete o[s], o[s] = a();
      }
    });
  }
  t.defineRelationGetter = r;
  var i = function() {
    function o() {
    }
    return o.prototype.createModel = function(s) {
      return { type: s };
    }, o.prototype.setId = function(s, a) {
      s.id = a;
    }, o.prototype.setAttributes = function(s, a) {
      Object.keys(a).forEach(function(c) {
        s[c] = a[c];
      });
    }, o.prototype.setMeta = function(s, a) {
      s.meta = a;
    }, o.prototype.setLinks = function(s, a) {
      s.links = a;
    }, o.prototype.setResourceIdObjMeta = function(s, a) {
      s.resourceIdObjMeta = a;
    }, o.prototype.setRelationships = function(s, a) {
      Object.keys(a).forEach(function(l) {
        typeof a[l] == "function" ? r(s, l, a[l]) : s[l] = a[l];
      });
      var c = Object.keys(a), u = s[t.RELATIONSHIP_NAMES_PROP];
      u && u.length ? s[t.RELATIONSHIP_NAMES_PROP] = e.__spreadArray(e.__spreadArray([], u, !0), c, !0).filter(function(l, f, h) {
        return h.indexOf(l) === f;
      }) : s[t.RELATIONSHIP_NAMES_PROP] = c;
    }, o.prototype.setRelationshipLinks = function(s, a, c) {
    }, o.prototype.setRelationshipMeta = function(s, a, c) {
    }, o;
  }();
  t.JsonPropertiesMapper = i;
})(z);
var g = {};
Object.defineProperty(g, "__esModule", { value: !0 });
g.DeserializeCache = g.jsonStringify = void 0;
function J(t) {
  var e;
  try {
    e = JSON.stringify(t);
  } catch (n) {
    e = "", console.warn(n);
  }
  return e;
}
g.jsonStringify = J;
var pt = function() {
  function t() {
    this.cachedModels = {};
  }
  return t.prototype.getCachedModel = function(e, n) {
    var r = this.createCacheKey(e, n);
    return this.cachedModels[r] || null;
  }, t.prototype.handleModel = function(e, n, r) {
    var i = this.createCacheKey(n, r), o = n.attributes || n.relationships;
    i && o && (this.cachedModels[i] = e);
  }, t.prototype.createCacheKey = function(e, n) {
    if (!(!e.id || !e.type)) {
      var r = n ? "".concat(n.type, "-").concat(n.id) : "";
      return n != null && n.meta && (r += "-".concat(J(n.meta))), e.meta ? "".concat(e.type, "-").concat(e.id, "-").concat(J(e.meta), "-").concat(r) : "".concat(e.type, "-").concat(e.id, "-").concat(r);
    }
  }, t;
}();
g.DeserializeCache = pt;
Object.defineProperty(B, "__esModule", { value: !0 });
var ht = v, dt = R, yt = O, bt = $, W = z, vt = g, _t = function() {
  function t(e) {
    this.modelPropertiesMapper = new W.ModelPropertiesMapper(), this.jsonPropertiesMapper = new W.JsonPropertiesMapper(), this.DeserializeCache = vt.DeserializeCache, this.ModelsSerializer = dt.default, this.JsonDeserializer = yt.default, e && e.modelPropertiesMapper && (this.modelPropertiesMapper = e.modelPropertiesMapper), e && e.jsonPropertiesMapper && (this.jsonPropertiesMapper = e.jsonPropertiesMapper), e && e.DeserializeCache && (this.DeserializeCache = e.DeserializeCache), e && e.ModelsSerializer && (this.ModelsSerializer = e.ModelsSerializer), e && e.JsonDeserializer && (this.JsonDeserializer = e.JsonDeserializer);
  }
  return t.prototype.serialize = function(e) {
    var n = e.stuff, r = e.includeNames;
    if (!n)
      throw new Error("Jsona can not serialize, stuff is not passed");
    var i = new this.ModelsSerializer(this.modelPropertiesMapper);
    return i.setStuff(n), r && i.setIncludeNames(r), i.build();
  }, t.prototype.deserialize = function(e, n) {
    if (!e)
      throw new Error("Jsona can not deserialize, body is not passed");
    var r = new this.DeserializeCache(), i = new this.JsonDeserializer(this.jsonPropertiesMapper, r, n);
    return typeof e == "string" ? i.setJsonParsedObject((0, ht.jsonParse)(e)) : i.setJsonParsedObject(e), i.build();
  }, t.prototype.denormalizeReduxObject = function(e) {
    var n = e.reduxObject, r = e.entityType, i = e.entityIds, o = e.returnBuilderInRelations, s = o === void 0 ? !1 : o;
    if (!n)
      throw new Error("Jsona can not denormalize ReduxObject, incorrect reduxObject passed");
    if (!r)
      throw new Error("Jsona can not denormalize ReduxObject, entityType is not passed");
    if (!n[r])
      return null;
    var a = new bt.default(this.jsonPropertiesMapper);
    return a.setReduxObject(n), a.setEntityType(r), a.setReturnBuilderInRelations(s), i && a.setEntityIds(Array.isArray(i) ? i : i.toString()), a.build();
  }, t;
}();
B.default = _t;
var M = {};
Object.defineProperty(M, "__esModule", { value: !0 });
M.SwitchCaseJsonMapper = M.SwitchCaseModelMapper = void 0;
var Ce = F, T = z, Ie = v, mt = function(t) {
  Ce.__extends(e, t);
  function e(n) {
    var r = t.call(this) || this, i = n || {}, o = i.switchAttributes, s = o === void 0 ? !0 : o, a = i.switchRelationships, c = a === void 0 ? !0 : a, u = i.switchType, l = u === void 0 ? !0 : u, f = i.switchChar, h = f === void 0 ? "-" : f;
    return r.switchAttributes = s, r.switchRelationships = c, r.switchType = l, r.switchChar = h, r.regex = new RegExp(/([a-z][A-Z0-9])/g), r;
  }
  return e.prototype.getType = function(n) {
    var r = t.prototype.getType.call(this, n);
    return !this.switchType || !r ? r : this.convertFromCamelCaseString(r);
  }, e.prototype.getAttributes = function(n) {
    var r = t.prototype.getAttributes.call(this, n);
    return !this.switchAttributes || !r ? r : this.convertFromCamelCase(r);
  }, e.prototype.getRelationships = function(n) {
    var r = t.prototype.getRelationships.call(this, n);
    return !this.switchRelationships || !r ? r : this.convertFromCamelCase(r);
  }, e.prototype.convertFromCamelCase = function(n) {
    var r = this;
    if (Array.isArray(n))
      return n.map(function(o) {
        return r.convertFromCamelCase(o);
      });
    if ((0, Ie.isPlainObject)(n)) {
      var i = {};
      return Object.entries(n).forEach(function(o) {
        var s = o[0], a = o[1], c = r.convertFromCamelCaseString(s);
        i[c] = r.convertFromCamelCase(a);
      }), i;
    }
    return n;
  }, e.prototype.convertFromCamelCaseString = function(n) {
    var r = this;
    return n.replace(this.regex, function(i) {
      return i[0] + r.switchChar + i[1].toLowerCase();
    });
  }, e;
}(T.ModelPropertiesMapper);
M.SwitchCaseModelMapper = mt;
var wt = function(t) {
  Ce.__extends(e, t);
  function e(n) {
    var r = t.call(this) || this, i = n || {}, o = i.camelizeAttributes, s = o === void 0 ? !0 : o, a = i.camelizeRelationships, c = a === void 0 ? !0 : a, u = i.camelizeType, l = u === void 0 ? !0 : u, f = i.camelizeMeta, h = f === void 0 ? !1 : f, p = i.switchChar, y = p === void 0 ? "-" : p;
    return r.camelizeAttributes = s, r.camelizeRelationships = c, r.camelizeType = l, r.camelizeMeta = h, r.switchChar = y, r.regex = new RegExp("".concat(r.switchChar, "([a-z0-9])"), "g"), r;
  }
  return e.prototype.createModel = function(n) {
    if (!this.camelizeType)
      return { type: n };
    var r = this.convertToCamelCaseString(n);
    return { type: r };
  }, e.prototype.setAttributes = function(n, r) {
    if (!this.camelizeAttributes)
      return t.prototype.setAttributes.call(this, n, r);
    Object.assign(n, this.convertToCamelCase(r));
  }, e.prototype.setMeta = function(n, r) {
    if (!this.camelizeMeta)
      return t.prototype.setMeta.call(this, n, r);
    n.meta = this.convertToCamelCase(r);
  }, e.prototype.setRelationships = function(n, r) {
    var i = this;
    t.prototype.setRelationships.call(this, n, r), this.camelizeRelationships && n[T.RELATIONSHIP_NAMES_PROP].forEach(function(o, s) {
      var a = i.convertToCamelCaseString(o);
      a !== o && (n[a] = n[o], delete n[o], n[T.RELATIONSHIP_NAMES_PROP][s] = a);
    });
  }, e.prototype.convertToCamelCase = function(n) {
    var r = this;
    if (Array.isArray(n))
      return n.map(function(o) {
        return r.convertToCamelCase(o);
      });
    if ((0, Ie.isPlainObject)(n)) {
      var i = {};
      return Object.entries(n).forEach(function(o) {
        var s = o[0], a = o[1], c = r.convertToCamelCaseString(s);
        i[c] = r.convertToCamelCase(a);
      }), i;
    }
    return n;
  }, e.prototype.convertToCamelCaseString = function(n) {
    return n.replace(this.regex, function(r) {
      return r[1].toUpperCase();
    });
  }, e;
}(T.JsonPropertiesMapper);
M.SwitchCaseJsonMapper = wt;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.SwitchCaseJsonMapper = t.SwitchCaseModelMapper = t.JsonPropertiesMapper = t.ModelPropertiesMapper = t.JsonDeserializer = t.ModelsSerializer = t.Jsona = void 0;
  var e = B;
  t.Jsona = e.default;
  var n = R;
  t.ModelsSerializer = n.default;
  var r = O;
  t.JsonDeserializer = r.default;
  var i = z;
  Object.defineProperty(t, "ModelPropertiesMapper", { enumerable: !0, get: function() {
    return i.ModelPropertiesMapper;
  } }), Object.defineProperty(t, "JsonPropertiesMapper", { enumerable: !0, get: function() {
    return i.JsonPropertiesMapper;
  } });
  var o = M;
  Object.defineProperty(t, "SwitchCaseModelMapper", { enumerable: !0, get: function() {
    return o.SwitchCaseModelMapper;
  } }), Object.defineProperty(t, "SwitchCaseJsonMapper", { enumerable: !0, get: function() {
    return o.SwitchCaseJsonMapper;
  } }), t.default = e.default;
})(H);
const gt = new H.Jsona({
  jsonPropertiesMapper: new H.SwitchCaseJsonMapper()
}), Mt = (...t) => gt.deserialize(...t), Rt = async (t, e, n) => {
  if (n.ok) {
    const r = await n.text();
    if (!r)
      return new Response(null, n);
    const i = Mt(r);
    return i ? new Response(JSON.stringify(i), n) : new Response(r, n);
  }
  return n;
}, Ot = (t, e) => {
  var n, r;
  P.isSSR || (r = (n = window.DD_RUM) == null ? void 0 : n.addError) == null || r.call(n, t, e);
}, Pt = (t, e) => {
  Ot(t, e);
}, St = async (t) => (Pt(t, {
  request: {
    url: t.request.url
  },
  response: {
    status: t.response.status,
    body: await jt(t.response)
  }
}), t), jt = async (t) => {
  try {
    return await t.clone().json();
  } catch {
    return await t.clone().text();
  }
}, Et = (t) => {
  if (P.isSSR)
    return t;
  const { origin: e } = window.location;
  return De.some(
    (r) => e.endsWith(r)
  ) ? {
    ...t,
    prefixUrl: e
  } : {
    ...t,
    prefixUrl: `${e}/${ee}`
  };
}, Tt = "Authorization", At = "Bearer", Ct = (t) => {
  const e = ze();
  if (e && qe(e)) {
    ke();
    return;
  }
  e && t.headers.set(Tt, `${At} ${e}`);
}, It = "X-Fondof-Beta", Dt = (t) => {
  P.isBeta && t.headers.set(It, "true");
}, zt = "X-Fondof-Is-Canary", qt = (t) => {
  P.isCanary && t.headers.set(zt, "true");
}, kt = "X-Fondof-Internal", Nt = (t) => {
  P.isInternal && t.headers.set(kt, "true");
}, Ht = "Accept-Language", xt = {
  de: "de_DE,de;q=0.8",
  en: "en_US,en;q=0.8",
  fr: "fr_FR,fr;q=0.8",
  es: "es_ES,es;q=0.8",
  da: "da_DK,dk;q=0.8",
  it: "it_IT,it;q=0.8"
}, Jt = () => xt[ee], Ut = (t) => t.headers.set(Ht, Jt());
let j;
const Bt = new Uint8Array(16);
function Lt() {
  if (!j && (j = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !j))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return j(Bt);
}
const d = [];
for (let t = 0; t < 256; ++t)
  d.push((t + 256).toString(16).slice(1));
function Ft(t, e = 0) {
  return d[t[e + 0]] + d[t[e + 1]] + d[t[e + 2]] + d[t[e + 3]] + "-" + d[t[e + 4]] + d[t[e + 5]] + "-" + d[t[e + 6]] + d[t[e + 7]] + "-" + d[t[e + 8]] + d[t[e + 9]] + "-" + d[t[e + 10]] + d[t[e + 11]] + d[t[e + 12]] + d[t[e + 13]] + d[t[e + 14]] + d[t[e + 15]];
}
const $t = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), X = {
  randomUUID: $t
};
function Kt(t, e, n) {
  if (X.randomUUID && !e && !t)
    return X.randomUUID();
  t = t || {};
  const r = t.random || (t.rng || Lt)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Ft(r);
}
const Y = "X-Anonymous-Customer-Unique-Id", Q = "uuid", Z = Ne.create("localStorage"), Gt = (t) => {
  let e = t.headers.get(Y) || Z.get(Q);
  e || (e = Kt(), Z.set(Q, e)), t.headers.set(Y, e);
}, K = (t, e) => {
  const n = [];
  for (const [r, i] of Object.entries(t))
    e[r] && n.push(i);
  return n;
}, Vt = (t) => (e, n) => {
  const r = K(t, n);
  for (const i of r) {
    const o = i(e, n);
    if (o instanceof Response)
      return o;
  }
}, Wt = (t) => async (e, n, r) => {
  const i = K(t, n);
  for (const o of i) {
    const s = await o(e, n, r);
    s instanceof Response && (r = s);
  }
  return r;
}, Xt = (t, e) => {
  const n = K(t, e);
  for (const r of n)
    e = r(e);
  return e;
}, Yt = Qe.extend({
  timeout: !1,
  retry: 0,
  headers: {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json;version=1.1"
  },
  fondOfInternal: !0,
  auth: !0,
  language: !0,
  uuid: !1,
  deserialize: !1,
  beta: !0,
  canary: !0
}), nr = {
  new: (t = {}) => {
    var e, n, r;
    return t.hooks = {
      ...t.hooks || {},
      beforeRequest: [
        Vt({
          fondOfInternal: Nt,
          auth: Ct,
          language: Ut,
          uuid: Gt,
          beta: Dt,
          canary: qt
        }),
        ...((e = t.hooks) == null ? void 0 : e.beforeRequest) || []
      ],
      afterResponse: [
        Wt({
          deserialize: Rt
        }),
        ...((n = t.hooks) == null ? void 0 : n.afterResponse) || []
      ],
      beforeError: [...((r = t.hooks) == null ? void 0 : r.beforeError) || [], St]
    }, Xt(
      {
        shopPrefixUrl: Et
      },
      t
    ), Yt.extend(t);
  }
}, Qt = (t) => (t == null ? void 0 : t.name) === "HTTPError", ir = (t) => Qt(t) && t.response.status === 404;
export {
  nr as default,
  Mt as deserialize,
  Qt as isHttpError,
  ir as isHttpNotFoundError
};
//# sourceMappingURL=api-client.js.map
